import React, {useEffect, useState} from "react";
import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../../Helpers/ErrorMessages";
import {formatDate} from "../../../Utils/ConvertDate";
import ObGynSidebar from "../../Utils/ObGynSidebar";
import {usePrint} from "../../../Utils/Templates/usePrint";
import PageTitle from "../../../Utils/smsTitle";
import {SubHeader} from "../../../../Containers/SubHeader";
import CustomDialog from "../../../Utils/Dialogs/CustomDialog";
import DoctorRadiologyResults from "../../../DoctorsModule/Radiology/RadiologyResults";
import {CenteredContainer, RightAlignedContainer} from "../../../Utils/styledComponents";
import RadiologyReport from "../../../Radiology/RadiologyReport";
import MainSnackbar from "../../../Utils/Snackbar/SmsSnackbar";
import ObGynPatientInfo from "../../Utils/ObGynPatientInfo";
import {
    FinishedStatus, P,
    PendingStatus,
    StyledIcon,
    StyledLibraryIcon, StyledRemoveIcon,
    ViewButton
} from "../../../DoctorsModule/doctorStyles";
import {LoadingGif} from "../../../Utils/Loader";
import {CollapsibleList, DataCell, ModuleTable} from "../../../Utils/Lists/CollapsibleList";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import TableRow from "@material-ui/core/TableRow";
import {bindActionCreators} from "redux";
import * as snackbarActions from "../../../../actions/snackbarActions";

import {connect} from "react-redux";
import {AddGynProcedure} from "../Procedure/AddProcedure";
import {AddGynRadiologyRequest} from "./AddGynRadiologyRequest";
import Textarea from "../../../Utils/FormInputs/Textarea";
import DeleteDialog from "../../../Utils/Dialogs/DeleteDialog";

const headData = [{item:'Test Name',toolTip:'Make imaging request here', isRequired:true},
    {item:'Indication', isRequired:true},{item:'Status', isRequired:true},{item:'Action', isRequired:false}]


const PreviousRadiologyRequest = ({actions, snackbars, match:{params}}) => {
    const {patient_number, visit_id, patient_type} = params;

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = !_token.user_roles_id ? "" : _token.user_roles_id;

    // get the doctor's name
    const doctor_name = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;

    const [scanRequests, setScanRequests] = useState([])
    const [status, setStatus] = useState('idle')
    const [id, setId] = useState('')
    const [openReport, setOpenReport] = useState(false)
    const [radiologyResults, setResults] = useState([]);
    const [scanResults, setScanResults] = useState({});
    const [activeChip, setActiveChip] = useState(0)
    const [openResult, setOpenResult] = useState(false)
    const [result_id, setResultId] = useState('')
    const [openDialog, setOpenDialog] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [isBlocking, setIsBlocking] = useState(false)
    const [isBlockDialog, setIsBlockDialog] = useState(false)
    const [isEditing, setIsEditing] = useState('idle')
    const [openDelete, setOpenDelete] = useState(false)
    const [deleteData, setDeleteData] = useState({})

    const isResolved = isSubmitted === 'resolved'
    const isResolvedEdit = isEditing === 'resolved'
    const isPendingEdit = isEditing === 'pending'


    useEffect(()=>{
        if(!id){
            return
        }
        const formData = new FormData();
        formData.append('visit_id', visit_id);
        axios.post(`${config.smsUrl}/cdoctor/get_scan_results_details_by_visit_id`, formData).then(res=>{
            const data = res.data;
            const dt = !data ? {} : data;
            const list = !dt.scan_result ? [] : dt.scan_result;
            const result = list[0] ?? {};
            const r_id = result.scan_result_id ?? '';
            retrieveResults(r_id, 0)
            setResults(list)
        }).catch(err=>{
            logoutErrorMessage(err,null, actions)
        })
    },[id]);

    const retrieveResults = (scan_result_id, active) => {
        const formData = new FormData();
        formData.append('scan_result_id', scan_result_id);
        axios.post(`${config.smsUrl}/cradiology/get_scan_results`, formData).then((res) => {
            const data = res.data;
            const dt = !data ? {} : data;
            setScanResults({...dt, patient_info:{...dt?.patient_info, visit_id}})
        }).catch(err => {
            logoutErrorMessage(err, null, actions)
        })
        setActiveChip(active)
    };


    useEffect(()=>{
        if (!result_id){
            return
        }
        retrieveResults(result_id)
        return ()=>{
            setScanResults({})
        }
    },[result_id])


    const groupByScanRequestId = (arr=[]) =>{
        let result = []
        let knowledge = {}
        arr.forEach(item =>{
            let id = formatDate(item.date_created);
            if(id in knowledge){
                result[knowledge[id]].scans.push(item)
            }else {
                knowledge[id] = result.length
                result.push({
                    id: item.scan_request_id,
                    date: formatDate(item.date_created),
                    doctor_name:`${item.doctor_firstname ? item.doctor_firstname:''} ${item.doctor_lastname ? item.doctor_lastname : ''}`,
                    scans: [item]
                })

            }
        })
        return result
    }

    useEffect(() => {
        const formData = new FormData();
        formData.append('visit_id', visit_id);
        setStatus('pending')
        axios.post(`${config.smsUrl}/cdoctor/get_previous_scan_request_by_visit_id`, formData).then(res => {
            const resp = res.data;
            const data = !resp ? [] : resp;
            const arr = groupByScanRequestId(data)
            const requests = arr.map(item=>({...item, open:true}))
            setScanRequests(requests);
            setStatus('success')
        }).catch(error => {
            logoutErrorMessage(error, null, actions)
            setStatus('error')
        });
    }, [isResolved, isResolvedEdit])

    const handleOpenEdit = (parentIdx,childIdx, editType) =>{
        const arr = scanRequests.map((item, pIndex)=>{
            if (parentIdx === pIndex){
                return {
                    ...item,
                    scans: item.scans.map((scan, cIndex)=>{
                        if (childIdx === cIndex){
                            return {
                                ...scan,
                                isEdit:editType
                            }
                        }
                        return scan
                    })
                }
            }
            return item

        })
        setScanRequests(arr)
    }

    const handleChangeValue = (event, parentIdx,childIdx) =>{
        const arr = scanRequests.map((item, pIndex)=>{
            if (parentIdx === pIndex){
                return {
                    ...item,
                    scans: item.scans.map((scan, cIndex)=>{
                        if (childIdx === cIndex){
                            return {
                                ...scan,
                                purpose:event.target.value
                            }
                        }
                        return scan
                    })
                }
            }
            return item

        })
        setScanRequests(arr)
    }

    const handleEditRadiology = (item, pIdx=0, cIndx=0) => {
        const params = {
            visit_id: visit_id,
            result_type: 3,
            user_roles_id,
            ...item
        }
        setIsEditing('pending');
        axios.post(`${config.smsUrl}/cdoctor/update_scan_request`, {...params}).then(() => {
            actions.snackbarActions.snackSuccess(`Test updated successfully`);
            setIsEditing('resolved');
            handleOpenEdit(pIdx, cIndx, false)
            setOpenDelete(false)
        }).catch(err => {
            errorMessages(err, null, actions)
            setIsEditing('rejected');
        })

    };


    const handleOpen = (id) =>{
        const itemsArr = scanRequests.map((item)=>{
            if(item.id === id){
                return {...item,open:!item.open}
            }else{
                return item
            }
        })
        setScanRequests(itemsArr)
    }

    const handleOpenReport  = (_id) =>{
        setId(_id)
        setOpenReport(true)
    }

    const handleCloseReport  = () =>{
        setOpenReport(false)
    }

    const handleOpenResult  = (_id) =>{
        setResultId(_id)
        setOpenResult(true)
    }

    const handleCloseResult  = () =>{
        setOpenResult(false)
    }

    const handleCloseDialog = () =>{
        if(isBlocking){
            setIsBlockDialog(true)
        }else{
            setIsBlockDialog(false)
            setIsBlocking(false)
            setOpenDialog(false);
        }
    }

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };

    const isLoading = status === 'pending'
    const isSuccess = status === 'success'
    const isError = status === 'error'

    const results = !scanResults ? {} : scanResults;
    const patient_info = !results.patient_info ? {} : results.patient_info;
    const result_details = !results.scan_result ? {} : results.scan_result;


    const {componentRef, handlePrint}  = usePrint();

    const {openBar, type, message} = snackbars;


    const deleteButtons = (
        <>
            <button type='button' onClick={()=>handleEditRadiology(deleteData)} disabled={isPendingEdit}
                    className='btn btn-sm small-btn sms-btn-dismiss mr-3'>{isPendingEdit ? 'Deleting...':'Delete'}</button>
            <button type='button' onClick={()=>setOpenDelete(false)} className='btn btn-sm small-btn sms-gray-btn mr-3'>Cancel</button>
        </>
    )

    return (
        <div className='journals'>
            <PageTitle title="Radiology Request"/>
            <SubHeader
                title="Doctor"
                subTitle="Radiology Request"
                doctor_name={doctor_name}
            >
                <div className="header-icon-margin-right-zero"><img src="/images/antenatal-blue.png"
                                                                    className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>

            <DeleteDialog handleClose={()=>setOpenDelete(false)} title='Delete Scan'
                          openDialog={openDelete} message='delete' text='scan'>
                {deleteButtons}
            </DeleteDialog>

            <CustomDialog title='Add Radiology Request' open={openDialog} handleClose={handleCloseDialog} maxWidth='md'>
                <AddGynRadiologyRequest {...{actions, visit_id,isSubmitted, setIsSubmitted, setOpenDialog,
                    isBlocking, setIsBlocking,isBlockDialog, setIsBlockDialog}}/>
            </CustomDialog>

            <CustomDialog open={openReport} handleClose={handleCloseReport} title='Radiology Report' maxWidth='lg'>
                <DoctorRadiologyResults {...{radiologyResults,  retrieveResults, scanResults, activeChip}}/>
            </CustomDialog>

            <CustomDialog open={openResult} handleClose={handleCloseResult} title='Radiology Report' maxWidth='lg'>
                <RightAlignedContainer>
                    <button onClick={handlePrint} className="btn sms-amber-btn  btn-sm">
                        Print
                    </button>
                </RightAlignedContainer>
                <div ref={componentRef}>
                    <RadiologyReport patient_info={patient_info} scan_result={result_details}/>
                </div>

            </CustomDialog>
            <MainSnackbar open={openBar} handleCloseBar={closeSnackbar} variant={type} message={message}/>
            <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} />
                <div style={{padding: '12px 16px'}}>
                    <button onClick={()=>setOpenDialog(true)}  type='button' className='btn btn-sm sms-info-btn mb-2'>Add Radiology Request</button>
                    {isLoading ? <CenteredContainer>
                        <LoadingGif/>
                    </CenteredContainer> : null}
                    {isSuccess ? scanRequests.length > 0 ? scanRequests.map((item, idx)=>{
                        // const isAdded = item.scans.some(dt=>dt.item_status !== 'Done')

                        const isDone = item.scans.some(dt=>dt.item_status === 'Done')
                        const payStatus =  item.scans.some(dt=>dt.pay_status === 0 || dt.pay_status === 3)
                        return(
                            <CollapsibleList key={item.id} open={item.open} name={item.date} handleOpen={()=>handleOpen(item.id)} button={
                                <>
                                    {/*{payStatus ? <Tooltip title='Edit Request'>*/}
                                    {/*    <IconButton onClick={()=>handleOpenEdit(item)} >*/}
                                    {/*        <StyledIcon/>*/}
                                    {/*    </IconButton>*/}
                                    {/*</Tooltip> : null}*/}
                                    {isDone ?
                                        <ViewButton onClick={()=>handleOpenReport(item.id)} className='btn btn-sm sms-info-btn btn-sm ml-3'>View  Report</ViewButton>
                                        : null}
                                </>
                            }
                                // user={ <ItemText  primary={`Requested By: ${item.doctor_name}`} />}
                            >
                                <ModuleTable headData={headData}>
                                    {item.scans.map((row, index) => {
                                        const isPending = row.item_status === 'Pending' || row.item_status === null;
                                        const isFinished = row.item_status === 'Done';
                                        const isRemoved = row.pay_status === 2;
                                        const isUnpaid = row.pay_status === 0 || (row.pay_status === 3 && isPending)
                                        const radiologyObj =     {
                                            hospital_scan_id: row.hospital_scan_id,
                                            purpose: row.purpose,
                                            scan_requests_detail_id: row.scan_requests_detail_id,
                                            bill_type:row.bill_type,
                                            bill_details:{
                                                service_id: row.service_id,
                                                quantity: 1,
                                                rate: row.rate,
                                                invoice_no:row.invoice_no ?? '',
                                                bill_id:row.bill_id,
                                            },
                                        }
                                        const saveButtons = (
                                            <>
                                                <button
                                                    type="submit"
                                                    className="btn btn-sm sms-btn small-btn mr-3"
                                                    onClick={() => handleEditRadiology({
                                                        scan_request_id:row.scan_request_id,
                                                        invoices_edited:[radiologyObj],
                                                        invoices_added:[], invoices_removed:[]
                                                    }, idx, index)}
                                                    style={{ marginTop: "5px", marginBottom: "5px" }}
                                                >
                                                    {isPendingEdit ? "Saving..." : "Save"}
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-sm sms-gray-btn small-btn"
                                                    onClick={() => handleOpenEdit(idx,index, false)}
                                                    style={{ marginTop: "5px", marginBottom: "5px" }}
                                                >
                                                    Cancel
                                                </button>
                                            </>
                                        );

                                        const updateButtons = row.isEdit ? saveButtons :  (
                                            <React.Fragment>
                                                <Tooltip title='Edit Request'>
                                                    <IconButton onClick={() => handleOpenEdit(idx, index, true)}>
                                                        <StyledIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title='Delete Request'>
                                                    <IconButton onClick={() => {
                                                        setOpenDelete(true)
                                                        setDeleteData({
                                                            scan_request_id:row.scan_request_id,
                                                            invoices_added: [],
                                                            invoices_edited: [],
                                                            invoices_removed: [radiologyObj]
                                                        })
                                                    }}>
                                                        <StyledRemoveIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                            </React.Fragment>
                                        )
                                        return(
                                            <TableRow
                                                key={index}
                                            >
                                                <DataCell>
                                                    {row.hospital_scan_name}
                                                </DataCell>

                                                <DataCell>{
                                                    row.isEdit ?
                                                        <Textarea as="textarea" id={`purpose-${index}`}
                                                                  value={row.purpose}
                                                                  onChange={e => handleChangeValue(e,idx ,index)}
                                                                  name="purpose"/>:
                                                    row.purpose
                                                }</DataCell>
                                                <DataCell>{isRemoved ? <PendingStatus>Scan excluded</PendingStatus>: isPending ? <PendingStatus>{row.item_status ? row.item_status : 'Pending'}</PendingStatus>:isFinished ? <FinishedStatus>{row.item_status}</FinishedStatus>: null}</DataCell>
                                                <DataCell>{isFinished ?
                                                    <Tooltip title='View Results'>
                                                        <IconButton onClick={()=>handleOpenResult(row.scan_result_id)}>
                                                            <StyledLibraryIcon/>
                                                        </IconButton>
                                                    </Tooltip> : null}
                                                    {isUnpaid ? updateButtons :  null}
                                                </DataCell>
                                            </TableRow>
                                        )})}
                                </ModuleTable>
                            </CollapsibleList>
                        )
                    }) : <CenteredContainer>
                        <P>No radiology requests submitted for patient, click the add radiology request button to submit a request</P>
                    </CenteredContainer>:null}
                    {isError ? <CenteredContainer>
                        <P>An error occurred on the server</P>
                    </CenteredContainer>:null}
                </div>
            </ObGynSidebar>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        snackbars: state.snackbar
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviousRadiologyRequest);


